export default "__VITE_ASSET__DkS9FXSZ__"